import React from "react";
import styles from "../styles/Loader.module.css";

const Loader = ({ color }) => {
  const colorClass = color === "white" ? styles.white : styles.blue;

  return (
    <div className={colorClass + " " + styles.ldsSpinner}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
